import { Link } from "react-router-dom";
import { LEGAL_LINKS } from "@common/legal";
import type { Session } from "../hooks/useSession";

/** The quiet end of the page: the small print and, out of the way, sign-in. */
export default function Footer({ session }: { session: Session }) {
  const { user, signIn, signOut } = session;
  return (
    <footer className="footer">
      <span className="muted small">Salvagers is a board game by Jake. Art is human-drawn.</span>
      <span className="muted small footer-legal">
        {LEGAL_LINKS.map((link, i) => (
          <span key={link.url}>
            {i > 0 && " · "}
            <a href={link.url}>{link.label}</a>
          </span>
        ))}
      </span>
      <span className="muted small footer-session">
        {user ? (
          <>
            <Link to="/account">{user.email}</Link>
            {" · "}
            <button className="link" onClick={signOut}>
              Sign out
            </button>
          </>
        ) : (
          <button className="link" onClick={signIn}>
            Sign in
          </button>
        )}
      </span>
    </footer>
  );
}
